import React, { useEffect, useState } from "react";
import { saasApi } from "../../api/saasApi";

export default function RevenueDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    saasApi.adminAnalyticsOverview().then((res) => setData(res.data));
  }, []);

  if (!data) return <p>Loading revenue…</p>;

  return (
    <div>
      <h1>Revenue dashboard</h1>
      <div className="saas-stats">
        <div className="saas-stat"><span>Total revenue</span><strong>₹{data.revenue?.total_inr?.toLocaleString("en-IN")}</strong></div>
        <div className="saas-stat"><span>MRR estimate</span><strong>₹{data.revenue?.mrr_estimate_inr?.toLocaleString("en-IN")}</strong></div>
        <div className="saas-stat"><span>Paid transactions</span><strong>{data.revenue?.paid_transactions}</strong></div>
      </div>
    </div>
  );
}
